// طرح‌های بودجه
// فرم مشترک طرح/برنامه (یک جدول با ستون نوع)، اینجا با فیلتر طرح باز می‌شود
import React from 'react';
import AccountingProgram from '../Accounting/AccountingProgram';

export default function BudgetPlan({ user, onBack }) {
  return <AccountingProgram user={user} onBack={onBack} initialKind={1} />;
}
